import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useSettingsStore = defineStore('settingsStore', () => {
  // Define a state that will be synced to localStorage
  const storedSettings = localStorage.getItem('settings') ? JSON.parse(localStorage.getItem('settings')) : {
    campaignsViewType: 'grid',
    campaignsFiltersVisible: ! window.matchMedia('(max-width: 768px)').matches,
    reportsFiltersVisible: ! window.matchMedia('(max-width: 768px)').matches,
  }
  
  // Always override filter visibility on mobile, regardless of stored value
  const isMobile = window.matchMedia('(max-width: 768px)').matches
  const settings = ref({
    ...storedSettings,
    campaignsFiltersVisible: isMobile ? false : storedSettings.campaignsFiltersVisible,
    reportsFiltersVisible: isMobile ? false : storedSettings.reportsFiltersVisible,
  })

  // Automatically sync the state with localStorage whenever it changes
  watch(
    settings,
    (newValue) => {
      localStorage.setItem('settings', JSON.stringify(newValue))
    },
    { deep: true } // Deep watch to track nested changes, if any
  )

  function setSettings(value) {
    settings.value = value
  }

  function toggleSetting(key) {
    settings.value[key] = !settings.value[key]
  }

  function setSetting(key, value) {
    settings.value[key] = value
  }

  function clearSettings() {
    localStorage.removeItem('settings')
    settings.value = {}
  }

  return { settings, setSettings, setSetting, toggleSetting, clearSettings }
})